import { actionIcons } from "components/HomeActionItems/ActionItemRow";
import { ReviewAndPayIcon } from "components/icons/ReviewAndPayIcon";
import {
  CHAT_CARD_TYPE,
  ESIGN_REQUEST_CUSTOM_TYPE,
  OPEN_ITEM_CUSTOM_TYPE,
  REQUESTED_DOCUMENTS_CUSTOM_TYPE,
  REQUESTED_INFO_CUSTOM_TYPE,
  SENSITIVE_DATA_CUSTOM_TYPE,
} from "constants/chatType";
import ChatInfoSmallRedirect from "static/images/ChatInfoSmallRedirect.svg";
import { MessageResponse } from "stream-chat";
import { DefaultStreamChatGenerics } from "stream-chat-react/dist/types/types";
import { CustomData } from "types/Models/reviewDocumentAndBalancingPayment";
import { PendingActionCardCTAS } from "./PendingActionCardCTAS";
import { Button } from "components/DesignSystem/Button/Button";
import { useDispatch } from "react-redux";
import { setScrollToMessageId } from "store/slices/messageToScrollTo";

export const PendingActionCard = ({
  message,
  groupId,
  completed,
}: {
  message: MessageResponse<DefaultStreamChatGenerics> & {
    custom_data: CustomData;
  };
  groupId: string;
  completed?: boolean;
}) => {
  const dispatch = useDispatch();
  let title = "";
  let subtitle = "";

  switch (message.custom_type) {
    case CHAT_CARD_TYPE: {
      title = message.custom_data.header;
      subtitle = "Review";
      break;
    }

    case OPEN_ITEM_CUSTOM_TYPE: {
      title = `Need clarifications`;
      subtitle = "Open items";
      break;
    }

    case REQUESTED_DOCUMENTS_CUSTOM_TYPE: {
      title = "Documents";
      subtitle = "Requested documents";
      break;
    }

    case REQUESTED_INFO_CUSTOM_TYPE: {
      title = "Information";
      subtitle = "Requested information";
      break;
    }

    case ESIGN_REQUEST_CUSTOM_TYPE: {
      title = "E-sign";
      subtitle = "Requested sign";
      break;
    }
    case SENSITIVE_DATA_CUSTOM_TYPE: {
      title = "Requested " + message.custom_data.header;
      subtitle = "Requested sensitive data";
      break;
    }

    default:
      return null;
  }

  return (
    <div className="t-flex t-items-center t-justify-between t-gap-2">
      <div className="t-flex t-gap-2 t-items-center">
        <div className="t-relative t-min-h-8 t-min-w-8 t-max-h-8 t-max-w-8 t-border t-border-solid t-border-neutral-0 t-rounded-full t-flex t-items-center t-justify-center">
          {actionIcons[message.custom_type] || <ReviewAndPayIcon />}
        </div>
        <div>
          <div
            className="t-flex t-items-center t-text-subtext-sm t-text-text-100"
            role="button"
            onClick={() => dispatch(setScrollToMessageId(message.id))}
          >
            <div className="t-line-clamp-1">{title}</div>
            &nbsp;
            <img src={ChatInfoSmallRedirect} alt="" />
          </div>
          <div className="t-text-caption t-text-text-30 t-line-clamp-1">
            {subtitle}
          </div>
        </div>
      </div>
      <div className="t-max-w-fit">
        <PendingActionCardCTAS
          message={message}
          groupId={groupId}
          completed={completed}
        />
      </div>
    </div>
  );
};
